import { gql } from "@apollo/client";

export const TRANSLATIONS_QUERY = gql`
    query getTranslations($languageCode: String!) {
        getTranslations(languageCode: $languageCode) {
            languageCode
            phraseId
            translation
        }
    }
`;

export const GET_TRANSLATION_BY_PHRASE_ID_AND_LANGUAGE = gql`
  query GetTranslationByPhraseIDAndLanguage($phraseID: String!, $languageCode: String!) {
    getTranslationByPhraseIDAndLanguage(phraseID: $phraseID,languageCode: $languageCode) {
      phraseId
      languageCode
      translation
    }
  }
`;